"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8424],{

/***/ 42445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1954);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36822);






var Iconify = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var icon = _param.icon, _width = _param.width, width = _width === void 0 ? 20 : _width, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "icon",
        "width",
        "sx"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        component: function() {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                icon: icon
            }, other));
        },
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            width: width,
            height: width
        }, sx)
    }, other));
});
/* harmony default export */ __webpack_exports__["Z"] = (Iconify);


/***/ }),

/***/ 76843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ animate_IconButtonAnimate; },
  "NM": function() { return /* reexport */ MotionContainer; },
  "DG": function() { return /* reexport */ MotionViewport; },
  "Wp": function() { return /* reexport */ varBounce; },
  "Ew": function() { return /* reexport */ varContainer; },
  "EU": function() { return /* reexport */ fade_varFade; }
});

// UNUSED EXPORTS: DialogAnimate, FabButtonAnimate, MotionLazyContainer, TRANSITION, TextAnimate, varBgColor, varBgKenburns, varBgPan, varFlip, varHover, varPath, varRotate, varScale, varSlide, varTranEnter, varTranExit, varTranHover, varZoom

;// CONCATENATED MODULE: ./src/components/animate/variants/path.ts
// ----------------------------------------------------------------------
var TRANSITION = {
    duration: 2,
    ease: [
        0.43,
        0.13,
        0.23,
        0.96
    ]
};
var varPath = {
    animate: {
        fillOpacity: [
            0,
            0,
            1
        ],
        pathLength: [
            1,
            0.4,
            0
        ],
        transition: TRANSITION
    }
};

;// CONCATENATED MODULE: ./src/components/animate/variants/transition.ts
// @types
// ----------------------------------------------------------------------
var varTranHover = function(props) {
    var duration = (props === null || props === void 0 ? void 0 : props.duration) || 0.32;
    var ease = (props === null || props === void 0 ? void 0 : props.ease) || [
        0.43,
        0.13,
        0.23,
        0.96
    ];
    return {
        duration: duration,
        ease: ease
    };
};
var varTranEnter = function(props) {
    var duration = (props === null || props === void 0 ? void 0 : props.durationIn) || 0.64;
    var ease = (props === null || props === void 0 ? void 0 : props.easeIn) || [
        0.43,
        0.13,
        0.23,
        0.96
    ];
    return {
        duration: duration,
        ease: ease
    };
};
var varTranExit = function(props) {
    var duration = (props === null || props === void 0 ? void 0 : props.durationOut) || 0.48;
    var ease = (props === null || props === void 0 ? void 0 : props.easeOut) || [
        0.43,
        0.13,
        0.23,
        0.96
    ];
    return {
        duration: duration,
        ease: ease
    };
};

;// CONCATENATED MODULE: ./src/components/animate/variants/fade.ts
// @types
//

// ----------------------------------------------------------------------
var fade_varFade = function(props) {
    var distance = (props === null || props === void 0 ? void 0 : props.distance) || 120;
    var durationIn = props === null || props === void 0 ? void 0 : props.durationIn;
    var durationOut = props === null || props === void 0 ? void 0 : props.durationOut;
    var easeIn = props === null || props === void 0 ? void 0 : props.easeIn;
    var easeOut = props === null || props === void 0 ? void 0 : props.easeOut;
    return {
        // IN
        in: {
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1,
                transition: varTranEnter
            },
            exit: {
                opacity: 0,
                transition: varTranExit
            }
        },
        inUp: {
            initial: {
                y: distance,
                opacity: 0
            },
            animate: {
                y: 0,
                opacity: 1,
                transition: varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                })
            },
            exit: {
                y: distance,
                opacity: 0,
                transition: varTranExit({
                    durationOut: durationOut,
                    easeOut: easeOut
                })
            }
        },
        inDown: {
            initial: {
                y: -distance,
                opacity: 0
            },
            animate: {
                y: 0,
                opacity: 1,
                transition: varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                })
            },
            exit: {
                y: -distance,
                opacity: 0,
                transition: varTranExit({
                    durationOut: durationOut,
                    easeOut: easeOut
                })
            }
        },
        inLeft: {
            initial: {
                x: -distance,
                opacity: 0
            },
            animate: {
                x: 0,
                opacity: 1,
                transition: varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                })
            },
            exit: {
                x: -distance,
                opacity: 0,
                transition: varTranExit({
                    durationOut: durationOut,
                    easeOut: easeOut
                })
            }
        },
        inRight: {
            initial: {
                x: distance,
                opacity: 0
            },
            animate: {
                x: 0,
                opacity: 1,
                transition: varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                })
            },
            exit: {
                x: distance,
                opacity: 0,
                transition: varTranExit({
                    durationOut: durationOut,
                    easeOut: easeOut
                })
            }
        },
        // OUT
        out: {
            initial: {
                opacity: 1
            },
            animate: {
                opacity: 0,
                transition: varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                })
            },
            exit: {
                opacity: 1,
                transition: varTranExit({
                    durationOut: durationOut,
                    easeOut: easeOut
                })
            }
        },
        outUp: {
            initial: {
                y: 0,
                opacity: 1
            },
            animate: {
                y: -distance,
                opacity: 0,
                transition: varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                })
            },
            exit: {
                y: 0,
                opacity: 1,
                transition: varTranExit({
                    durationOut: durationOut,
                    easeOut: easeOut
                })
            }
        },
        outDown: {
            initial: {
                y: 0,
                opacity: 1
            },
            animate: {
                y: distance,
                opacity: 0,
                transition: varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                })
            },
            exit: {
                y: 0,
                opacity: 1,
                transition: varTranExit({
                    durationOut: durationOut,
                    easeOut: easeOut
                })
            }
        },
        outLeft: {
            initial: {
                x: 0,
                opacity: 1
            },
            animate: {
                x: -distance,
                opacity: 0,
                transition: varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                })
            },
            exit: {
                x: 0,
                opacity: 1,
                transition: varTranExit({
                    durationOut: durationOut,
                    easeOut: easeOut
                })
            }
        },
        outRight: {
            initial: {
                x: 0,
                opacity: 1
            },
            animate: {
                x: distance,
                opacity: 0,
                transition: varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                })
            },
            exit: {
                x: 0,
                opacity: 1,
                transition: varTranExit({
                    durationOut: durationOut,
                    easeOut: easeOut
                })
            }
        }
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
;// CONCATENATED MODULE: ./src/components/animate/variants/bounce.ts
// @types

//

// ----------------------------------------------------------------------
var varBounce = function(props) {
    var durationIn = props === null || props === void 0 ? void 0 : props.durationIn;
    var durationOut = props === null || props === void 0 ? void 0 : props.durationOut;
    var easeIn = props === null || props === void 0 ? void 0 : props.easeIn;
    var easeOut = props === null || props === void 0 ? void 0 : props.easeOut;
    return {
        // IN
        in: {
            initial: {},
            animate: {
                scale: [
                    0.3,
                    1.1,
                    0.9,
                    1.03,
                    0.97,
                    1
                ],
                opacity: [
                    0,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                transition: varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                })
            },
            exit: {
                scale: [
                    0.9,
                    1.1,
                    0.3
                ],
                opacity: [
                    1,
                    1,
                    0
                ]
            }
        },
        inUp: {
            initial: {},
            animate: {
                y: [
                    720,
                    -24,
                    12,
                    -4,
                    0
                ],
                scaleY: [
                    4,
                    0.9,
                    0.95,
                    0.985,
                    1
                ],
                opacity: [
                    0,
                    1,
                    1,
                    1,
                    1
                ],
                transition: (0,src_object_spread/* default */.Z)({}, varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                }))
            },
            exit: {
                y: [
                    12,
                    -24,
                    720
                ],
                scaleY: [
                    0.985,
                    0.9,
                    3
                ],
                opacity: [
                    1,
                    1,
                    0
                ],
                transition: varTranExit({
                    durationOut: durationOut,
                    easeOut: easeOut
                })
            }
        },
        inDown: {
            initial: {},
            animate: {
                y: [
                    -720,
                    24,
                    -12,
                    4,
                    0
                ],
                scaleY: [
                    4,
                    0.9,
                    0.95,
                    0.985,
                    1
                ],
                opacity: [
                    0,
                    1,
                    1,
                    1,
                    1
                ],
                transition: varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                })
            },
            exit: {
                y: [
                    -12,
                    24,
                    -720
                ],
                scaleY: [
                    0.985,
                    0.9,
                    3
                ],
                opacity: [
                    1,
                    1,
                    0
                ],
                transition: varTranExit({
                    durationOut: durationOut,
                    easeOut: easeOut
                })
            }
        },
        inLeft: {
            initial: {},
            animate: {
                x: [
                    -720,
                    24,
                    -12,
                    4,
                    0
                ],
                scaleX: [
                    3,
                    1,
                    0.98,
                    0.995,
                    1
                ],
                opacity: [
                    0,
                    1,
                    1,
                    1,
                    1
                ],
                transition: varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                })
            },
            exit: {
                x: [
                    0,
                    24,
                    -720
                ],
                scaleX: [
                    1,
                    0.9,
                    2
                ],
                opacity: [
                    1,
                    1,
                    0
                ],
                transition: varTranExit({
                    durationOut: durationOut,
                    easeOut: easeOut
                })
            }
        },
        inRight: {
            initial: {},
            animate: {
                x: [
                    720,
                    -24,
                    12,
                    -4,
                    0
                ],
                scaleX: [
                    3,
                    1,
                    0.98,
                    0.995,
                    1
                ],
                opacity: [
                    0,
                    1,
                    1,
                    1,
                    1
                ],
                transition: varTranEnter({
                    durationIn: durationIn,
                    easeIn: easeIn
                })
            },
            exit: {
                x: [
                    0,
                    -24,
                    720
                ],
                scaleX: [
                    1,
                    0.9,
                    2
                ],
                opacity: [
                    1,
                    1,
                    0
                ],
                transition: varTranExit({
                    durationOut: durationOut,
                    easeOut: easeOut
                })
            }
        },
        // OUT
        out: {
            animate: {
                scale: [
                    0.9,
                    1.1,
                    0.3
                ],
                opacity: [
                    1,
                    1,
                    0
                ]
            }
        },
        outUp: {
            animate: {
                y: [
                    -12,
                    24,
                    -720
                ],
                scaleY: [
                    0.985,
                    0.9,
                    3
                ],
                opacity: [
                    1,
                    1,
                    0
                ]
            }
        },
        outDown: {
            animate: {
                y: [
                    12,
                    -24,
                    720
                ],
                scaleY: [
                    0.985,
                    0.9,
                    3
                ],
                opacity: [
                    1,
                    1,
                    0
                ]
            }
        },
        outLeft: {
            animate: {
                x: [
                    0,
                    24,
                    -720
                ],
                scaleX: [
                    1,
                    0.9,
                    2
                ],
                opacity: [
                    1,
                    1,
                    0
                ]
            }
        },
        outRight: {
            animate: {
                x: [
                    0,
                    -24,
                    720
                ],
                scaleX: [
                    1,
                    0.9,
                    2
                ],
                opacity: [
                    1,
                    1,
                    0
                ]
            }
        }
    };
};

;// CONCATENATED MODULE: ./src/components/animate/variants/container.ts
// ----------------------------------------------------------------------
var varContainer = function(props) {
    var staggerIn = (props === null || props === void 0 ? void 0 : props.staggerIn) || 0.05;
    var delayIn = (props === null || props === void 0 ? void 0 : props.staggerIn) || 0.05;
    var staggerOut = (props === null || props === void 0 ? void 0 : props.staggerIn) || 0.05;
    return {
        animate: {
            transition: {
                staggerChildren: staggerIn,
                delayChildren: delayIn
            }
        },
        exit: {
            transition: {
                staggerChildren: staggerOut,
                staggerDirection: -1
            }
        }
    };
};

;// CONCATENATED MODULE: ./src/components/animate/variants/index.ts













// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/animate/DialogAnimate.tsx





// @mui

//

function DialogAnimate(_param) {
    var _open = _param.open, open = _open === void 0 ? false : _open, variants = _param.variants, onClose = _param.onClose, children = _param.children, sx = _param.sx, other = _object_without_properties(_param, [
        "open",
        "variants",
        "onClose",
        "children",
        "sx"
    ]);
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        children: open && /*#__PURE__*/ _jsx(Dialog, _object_spread_props(_object_spread({
            fullWidth: true,
            maxWidth: "xs",
            open: open,
            onClose: onClose,
            PaperComponent: function(props) {
                return /*#__PURE__*/ _jsxs(Box, _object_spread_props(_object_spread({
                    component: m.div
                }, variants || varFade({
                    distance: 120,
                    durationIn: 0.32,
                    durationOut: 0.24,
                    easeIn: "easeInOut"
                }).inUp), {
                    sx: {
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            onClick: onClose,
                            sx: {
                                width: "100%",
                                height: "100%",
                                position: "fixed"
                            }
                        }),
                        /*#__PURE__*/ _jsx(Paper, _object_spread_props(_object_spread({
                            sx: sx
                        }, props), {
                            children: props.children
                        }))
                    ]
                }));
            }
        }, other), {
            children: children
        }))
    });
}

;// CONCATENATED MODULE: ./src/components/animate/TextAnimate.tsx





// @mui

//

function TextAnimate(_param) {
    var text = _param.text, variants = _param.variants, sx = _param.sx, other = _object_without_properties(_param, [
        "text",
        "variants",
        "sx"
    ]);
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        component: m.h1,
        sx: _object_spread({
            typography: "h1",
            overflow: "hidden",
            display: "inline-flex"
        }, sx)
    }, other), {
        children: text.split("").map(function(letter, index) {
            return /*#__PURE__*/ _jsx(m.span, {
                variants: variants || varFade().inUp,
                children: letter
            }, index);
        })
    }));
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/animate/FabButtonAnimate.tsx






// @mui


var FabButtonAnimate = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(_param, ref) {
    var _color = _param.color, color = _color === void 0 ? "primary" : _color, _size = _param.size, size = _size === void 0 ? "large" : _size, children = _param.children, sx = _param.sx, sxWrap = _param.sxWrap, other = _object_without_properties(_param, [
        "color",
        "size",
        "children",
        "sx",
        "sxWrap"
    ]);
    var theme = useTheme();
    if (color === "default" || color === "inherit" || color === "primary" || color === "secondary") {
        return /*#__PURE__*/ _jsx(AnimateWrap, {
            size: size,
            sxWrap: sxWrap,
            children: /*#__PURE__*/ _jsx(Fab, _object_spread_props(_object_spread({
                ref: ref,
                size: size,
                color: color,
                sx: sx
            }, other), {
                children: children
            }))
        });
    }
    return /*#__PURE__*/ _jsx(AnimateWrap, {
        size: size,
        sxWrap: sxWrap,
        children: /*#__PURE__*/ _jsx(Fab, _object_spread_props(_object_spread({
            ref: ref,
            size: size,
            sx: _object_spread({
                boxShadow: theme.customShadows[color],
                color: theme.palette[color].contrastText,
                bgcolor: theme.palette[color].main,
                "&:hover": {
                    bgcolor: theme.palette[color].dark
                }
            }, sx)
        }, other), {
            children: children
        }))
    });
})));
/* harmony default export */ var animate_FabButtonAnimate = ((/* unused pure expression or super */ null && (FabButtonAnimate)));
var varSmall = {
    hover: {
        scale: 1.07
    },
    tap: {
        scale: 0.97
    }
};
var varMedium = {
    hover: {
        scale: 1.06
    },
    tap: {
        scale: 0.98
    }
};
var varLarge = {
    hover: {
        scale: 1.05
    },
    tap: {
        scale: 0.99
    }
};
function AnimateWrap(param) {
    var size = param.size, children = param.children, sxWrap = param.sxWrap;
    var isSmall = size === "small";
    var isLarge = size === "large";
    return /*#__PURE__*/ _jsx(Box, {
        component: m.div,
        whileTap: "tap",
        whileHover: "hover",
        variants: isSmall && varSmall || isLarge && varLarge || varMedium,
        sx: _object_spread({
            display: "inline-flex"
        }, sxWrap),
        children: children
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(32970);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(36822);
;// CONCATENATED MODULE: ./src/components/animate/IconButtonAnimate.tsx






// @mui

// ----------------------------------------------------------------------
var IconButtonAnimate = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, _size = _param.size, size = _size === void 0 ? "medium" : _size, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "children",
        "size"
    ]);
    return (0,jsx_runtime.jsx)(IconButtonAnimate_AnimateWrap, {
        size: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            size: size,
            ref: ref
        }, other), {
            children: children
        }))
    });
});
/* harmony default export */ var animate_IconButtonAnimate = (IconButtonAnimate);
var IconButtonAnimate_varSmall = {
    hover: {
        scale: 1.1
    },
    tap: {
        scale: 0.95
    }
};
var IconButtonAnimate_varMedium = {
    hover: {
        scale: 1.09
    },
    tap: {
        scale: 0.97
    }
};
var IconButtonAnimate_varLarge = {
    hover: {
        scale: 1.08
    },
    tap: {
        scale: 0.99
    }
};
function IconButtonAnimate_AnimateWrap(param) {
    var size = param.size, children = param.children;
    var isSmall = size === "small";
    var isLarge = size === "large";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        component: motion_minimal.m.div,
        whileTap: "tap",
        whileHover: "hover",
        variants: isSmall && IconButtonAnimate_varSmall || isLarge && IconButtonAnimate_varLarge || IconButtonAnimate_varMedium,
        sx: {
            display: "inline-flex"
        },
        children: children
    });
}

// EXTERNAL MODULE: ./src/hooks/useResponsive.ts
var useResponsive = __webpack_require__(10653);
;// CONCATENATED MODULE: ./src/components/animate/MotionViewport.tsx





// @mui

// hooks

//

function MotionViewport(_param) {
    var children = _param.children, _disableAnimatedMobile = _param.disableAnimatedMobile, disableAnimatedMobile = _disableAnimatedMobile === void 0 ? true : _disableAnimatedMobile, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "children",
        "disableAnimatedMobile"
    ]);
    var isDesktop = (0,useResponsive/* default */.Z)("up", "sm");
    if (!isDesktop && disableAnimatedMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, other), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        component: motion_minimal.m.div,
        initial: "initial",
        whileInView: "animate",
        viewport: {
            once: true,
            amount: 0.3
        },
        variants: varContainer()
    }, other), {
        children: children
    }));
}

;// CONCATENATED MODULE: ./src/components/animate/MotionContainer.tsx





// @mui

//

function MotionContainer(_param) {
    var animate = _param.animate, _action = _param.action, action = _action === void 0 ? false : _action, children = _param.children, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "animate",
        "action",
        "children"
    ]);
    if (action) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            component: motion_minimal.m.div,
            initial: false,
            animate: animate ? "animate" : "exit",
            variants: varContainer()
        }, other), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        component: motion_minimal.m.div,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        variants: varContainer()
    }, other), {
        children: children
    }));
}

// EXTERNAL MODULE: ./src/components/animate/MotionLazyContainer.tsx + 1 modules
var MotionLazyContainer = __webpack_require__(30152);
;// CONCATENATED MODULE: ./src/components/animate/index.ts
// ----------------------------------------------------------------------










/***/ }),

/***/ 10653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useResponsive; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98396);
// @mui


function useResponsive(query, key, start, end) {
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var mediaUp = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(theme.breakpoints.up(key));
    var mediaDown = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(theme.breakpoints.down(key));
    var mediaBetween = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(theme.breakpoints.between(start, end));
    var mediaOnly = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(theme.breakpoints.only(key));
    if (query === "up") {
        return mediaUp;
    }
    if (query === "down") {
        return mediaDown;
    }
    if (query === "between") {
        return mediaBetween;
    }
    if (query === "only") {
        return mediaOnly;
    }
}


/***/ })

}]);